export class FooterAccessConfig {
  public static readonly hideOnRoutes = [
    '/workflows/new',
    '/workflows/continue',
    '/templates/new',
    '/workflows/edit',
    '/templates/edit',
    '/campaigns/new',
  ];
}
